import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./methodology.css";

const PDF = process.env.REACT_APP_METHODOLOGY; // or Adaptation
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";

const Methodology = () => {
  const [numPages, setNumPages] = useState(null);
  const [pagesToRender, setPagesToRender] = useState([]);

  const BATCH_SIZE = 5; // number of pages to render at once
  const [batchIndex, setBatchIndex] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPagesToRender(
      Array.from({ length: Math.min(BATCH_SIZE, numPages) }, (_, i) => i + 1)
    );
  };

  useEffect(() => {
    if (!numPages) return;

    if (pagesToRender.length < numPages) {
      const timer = setTimeout(() => {
        const nextBatch = Array.from(
          { length: Math.min(BATCH_SIZE, numPages - pagesToRender.length) },
          (_, i) => pagesToRender.length + i + 1
        );
        setPagesToRender((prev) => [...prev, ...nextBatch]);
      }, 50); // small delay to avoid blocking UI
      return () => clearTimeout(timer);
    }
  }, [pagesToRender, numPages]);

  return (
    <div className="met_parent">
      <Document file={PDF} onLoadSuccess={onDocumentLoadSuccess}>
        {pagesToRender.map((pageNumber) => (
          <Page
            key={`page_${pageNumber}`}
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    </div>
  );
};

export default Methodology;
